import { Card, Table } from "antd";
import { PageHeader } from "../../shared/ui/PageHeader";
import { DataCard } from "../../shared/ui/DataCard";
import { useIsMobile } from "../../shared/hooks/useIsMobile";
import { useResumoInstalacoes } from "./hooks";

const PLATAFORMAS = [
  { key: "ANDROID", label: "Android" },
  { key: "IOS", label: "iPhone" },
  { key: "DESKTOP", label: "Computador" },
];

// O dia chega como AAAA-MM-DD; reordenar o texto evita o deslocamento de fuso
// que new Date() causaria.
const formatDia = (dia) => dia.split("-").reverse().join("/");

const columns = [
  { title: "Dia", dataIndex: "dia", key: "dia", render: formatDia },
  ...PLATAFORMAS.map(({ key, label }) => ({ title: label, dataIndex: key, key })),
  { title: "Total", dataIndex: "total", key: "total" },
];

export default function Instalacoes() {
  const isMobile = useIsMobile();
  const { data, isLoading, isError } = useResumoInstalacoes();
  const porDia = data?.porDia ?? [];

  return (
    <div className="te-page-wrap te-stack">
      <PageHeader
        title="Instalações"
        subtitle="Quantas pessoas instalaram o app do cliente."
        metricLabel="Instalações"
        metricValue={data?.total ?? 0}
      />

      {isError ? (
        <Card className="te-card">
          <div className="te-empty">Não foi possível carregar as instalações. Tente novamente.</div>
        </Card>
      ) : (
        <>
          <Card className="te-card">
            <div style={{ marginBottom: 18 }}>
              <h3 style={{ margin: 0, color: "var(--te-primary)" }}>Por plataforma</h3>
              <p className="te-kicker">
                Conta a primeira abertura do app já instalado, uma vez por aparelho. Quem
                desinstala continua na conta.
              </p>
            </div>
            <div className="te-split-grid te-split-grid--three">
              {PLATAFORMAS.map(({ key, label }) => (
                <div key={key}>
                  <span className="te-muted">{label}</span>
                  <div className="te-page-header-grid__metric">
                    {data?.porPlataforma?.[key] ?? 0}
                  </div>
                </div>
              ))}
            </div>
          </Card>

          <Card className="te-card">
            <div style={{ marginBottom: 16 }}>
              <h3 style={{ margin: 0, color: "var(--te-primary)" }}>Últimos 30 dias</h3>
              <p className="te-kicker">Só aparecem os dias em que alguém instalou o app.</p>
            </div>
            {isMobile ? (
              isLoading ? (
                <div className="te-empty">Carregando...</div>
              ) : porDia.length === 0 ? (
                <div className="te-empty">Nenhuma instalação nos últimos 30 dias.</div>
              ) : (
                <div className="te-stack">
                  {porDia.map((dia) => (
                    <DataCard
                      key={dia.dia}
                      title={formatDia(dia.dia)}
                      rows={[
                        ...PLATAFORMAS.map(({ key, label }) => ({ label, value: dia[key] })),
                        { label: "Total", value: dia.total },
                      ]}
                    />
                  ))}
                </div>
              )
            ) : (
              <Table
                dataSource={porDia}
                columns={columns}
                rowKey="dia"
                loading={isLoading}
                locale={{ emptyText: "Nenhuma instalação nos últimos 30 dias." }}
                pagination={{ pageSize: 10, showSizeChanger: false }}
              />
            )}
          </Card>
        </>
      )}
    </div>
  );
}
